"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function formatLocalDateTime(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'M/D/YYYY';
  var timeFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'h:mm a';
  var at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'at';
  var dateMoment;

  // use new Date(date) for moment deprecation warning
  // https://github.com/moment/moment/issues/1407

  var dateObj = new Date(date);
  var isValidDate = (0, _moment["default"])(dateObj).isValid();
  if (!isValidDate || _lodash["default"].isNil(date)) {
    return '';
  }
  if (_lodash["default"].isNumber(date)) {
    dateMoment = _moment["default"].unix(dateObj);
  }
  if (_lodash["default"].isString(date)) {
    dateMoment = (0, _moment["default"])(dateObj);
  }
  return dateMoment.format("".concat(dateFormat, " [").concat(at, "] ").concat(timeFormat));
}
var _default = exports["default"] = formatLocalDateTime;